import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, Calendar, Clock, MapPinned, Square } from "lucide-react";
import { StatusPill } from "@/components/StatusPill";
import { toast } from "sonner";

export default function ProfessionalShifts() {
  const [assignments, setAssignments] = useState([]);
  const load = () => api.get("/assignments").then((r) => setAssignments(r.data));
  useEffect(() => { load(); }, []);

  const checkIn = async (id) => {
    try { await api.post(`/assignments/${id}/check-in`, { method: "gps" }); toast.success("Checked in"); load(); } catch { toast.error("Failed"); }
  };
  const checkOut = async (id) => {
    try { await api.post(`/assignments/${id}/check-out`, {}); toast.success("Checked out — timesheet created"); load(); } catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="pro-shifts-page">
      <h1 className="text-2xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>My Shifts</h1>
      {assignments.map((a) => (
        <Card key={a.id} data-testid={`shift-card-${a.id}`}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-bold text-slate-900">{a.facility?.name}</div>
                <div className="text-xs text-slate-500">{a.facility?.facility_type}</div>
              </div>
              <StatusPill status={a.status} />
            </div>
            <div className="mt-3 space-y-1 text-sm text-slate-700">
              <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-brand-teal" />{a.facility?.address}, {a.facility?.city}</div>
              <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-brand-teal" />{a.request?.shift_date}</div>
              <div className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-brand-teal" />{a.request?.start_time}-{a.request?.end_time}</div>
            </div>
            <div className="mt-4">
              {a.status === "confirmed" && (
                <Button onClick={() => checkIn(a.id)} className="w-full bg-green-600 hover:bg-green-700 h-12" data-testid={`check-in-${a.id}`}>
                  <MapPinned className="w-4 h-4 mr-2" />Check In (GPS)
                </Button>
              )}
              {a.status === "checked_in" && (
                <Button onClick={() => checkOut(a.id)} className="w-full bg-brand-navy hover:bg-brand-blue h-12" data-testid={`check-out-${a.id}`}>
                  <Square className="w-4 h-4 mr-2" />Check Out
                </Button>
              )}
              {a.status === "completed" && (
                <div className="text-center text-sm text-green-600 font-semibold">Shift completed ✓</div>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
      {assignments.length === 0 && <div className="text-center text-sm text-slate-500 py-12">No shifts assigned</div>}
    </div>
  );
}
